import React from "react";
import { FaArrowUp, FaArrowDown } from "react-icons/fa";
import "./productTable.css";

const productData = [
  { id: 1, product: "Lorem ipsum", status: "In progress", progress: 85, trend: "up" },
  { id: 2, product: "Aliquam", status: "New", progress: 35, trend: "down" },
  { id: 3, product: "Lorem ipsum", status: "Overdue", progress: 40, trend: "down" },
  { id: 4, product: "Aliquam", status: "Out of stock", progress: 100, trend: "up" },
  { id: 5, product: "Lorem ipsum", status: "In progress", progress: 10, trend: "down" },
  { id: 6, product: "Aliquam", status: "New", progress: 38, trend: "up" },
];

const ProductTableComponent = () => {
  const getStatusColor = (status) => {
    switch (status) {
      case "In progress":
        return "#4caf50";
      case "New":
        return "#e65100";
      case "Overdue":
        return "#f44336";
      case "Out of stock":
        return "#2196f3";
      default:
        return "#4b4b4b";
    }
  };

  return (
    <div className="product-table-box">
      <h3 className="chart-title">Products</h3>
      <div className="table-container">
        <table className="product-table">
          <thead>
            <tr>
              <th>S.NO</th>
              <th>PRODUCT</th>
              <th>STATUS</th>
              <th>PROGRESS</th>
            </tr>
          </thead>
          <tbody>
            {productData.map((product) => (
              <tr key={product.id}>
                <td>{product.id}</td>
                <td>{product.product}</td>
                <td>
                  <span
                    className="status-badge"
                    style={{ backgroundColor: getStatusColor(product.status) }}
                  >
                    {product.status}
                  </span>
                </td>
                <td>
                  <div className="progress-cell">
                    <span className="progress-text">{product.progress}%</span>
                    {product.trend === "up" ? (
                      <FaArrowUp className="trend-icon up" />
                    ) : (
                      <FaArrowDown className="trend-icon down" />
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ProductTableComponent;




